<template>
  <BaseSimpleLayout class="master-list">
    <template #title>マスタ一覧</template>
    <template #main>
      <div class="master-list-button-line">
        <ScreenPermissionGate code="ITEM">
          <el-button
            class="unit-master-list-button-item"
            type="primary"
            size="large"
            @click="router.push('/master/item')"
          >
            単品マスタ
          </el-button>
        </ScreenPermissionGate>
        <ScreenPermissionGate code="PACKAGE">
          <el-button
            class="unit-master-list-button-package"
            type="primary"
            size="large"
            @click="router.push('/master/package')"
          >
            パッケージマスタ
          </el-button>
        </ScreenPermissionGate>
        <ScreenPermissionGate code="PRODUCT">
          <el-button
            class="unit-master-list-button-product"
            type="primary"
            size="large"
            @click="router.push('/master/product')"
          >
            製品マスタ
          </el-button>
        </ScreenPermissionGate>
        <ScreenPermissionGate code="CAR">
          <el-button
            class="unit-master-list-button-support-shop"
            type="primary"
            size="large"
            @click="router.push('/master/carinfo')"
          >
            車両情報マスタ
          </el-button>
        </ScreenPermissionGate>
        <ScreenPermissionGate code="CAR_MAKER">
          <el-button
            class="unit-master-list-button-support-shop"
            type="primary"
            size="large"
            @click="router.push('/master/carmaker')"
          >
            車メーカマスタ
          </el-button>
        </ScreenPermissionGate>
      </div>
      <div class="master-list-button-line">
        <ScreenPermissionGate code="FINANCE">
          <el-button
            class="unit-master-list-button-finance"
            type="primary"
            size="large"
            @click="router.push('/master/finance')"
          >
            ファイナンスマスタ
          </el-button>
        </ScreenPermissionGate>
        <ScreenPermissionGate code="COMPANY_GROUP">
          <el-button
            class="unit-master-list-button-company"
            type="primary"
            size="large"
            @click="router.push('/master/companygroup')"
          >
            販売店グループマスタ
          </el-button>
        </ScreenPermissionGate>
        <ScreenPermissionGate code="COMPANY">
          <el-button
            class="unit-master-list-button-company"
            type="primary"
            size="large"
            @click="router.push('/master/company')"
          >
            販売店企業マスタ
          </el-button>
        </ScreenPermissionGate>
        <ScreenPermissionGate code="SHOP">
          <el-button
            class="unit-master-list-button-shop"
            type="primary"
            size="large"
            @click="router.push('/master/shop')"
          >
            販売店マスタ
          </el-button>
        </ScreenPermissionGate>
        <ScreenPermissionGate code="SUPPORT_SHOP">
          <el-button
            class="unit-master-list-button-support-shop"
            type="primary"
            size="large"
            @click="router.push('/master/supportshop')"
          >
            サポート店マスタ
          </el-button>
        </ScreenPermissionGate>
        <ScreenPermissionGate code="SUPPLIER">
          <el-button
            class="unit-master-list-button-supplier"
            type="primary"
            size="large"
            @click="router.push('/master/supplier')"
          >
            仕入先マスタ
          </el-button>
        </ScreenPermissionGate>
        <ScreenPermissionGate code="SUB_CATEGORY">
          <el-button
            class="unit-master-list-button-sub-category"
            type="primary"
            size="large"
            @click="router.push('/master/subCategory')"
          >
            分類マスタ
          </el-button>
        </ScreenPermissionGate>
      </div>
      <div class="master-list-button-line">
        <ScreenPermissionGate code="MCCS_SETTINGS_ITEM">
          <el-button
            class="unit-master-list-button-mccs"
            type="primary"
            size="large"
            @click="router.push('/master/mccs-settings')"
          >
            MCCS設定項目
          </el-button>
        </ScreenPermissionGate>
        <ScreenPermissionGate code="MCCS_FINANCE_SETTINGS">
          <el-button
            class="unit-master-list-button-finance-settings"
            type="primary"
            size="large"
            @click="router.push('/master/mccs-finance-settings')"
          >
            MCCSファイナンス別設定
          </el-button>
        </ScreenPermissionGate>
        <ScreenPermissionGate code="ORDER_AUTO_MAP">
          <el-button
            class="unit-master-list-button-order-auto-maps"
            type="primary"
            size="large"
            @click="router.push('/master/order-auto-maps')"
          >
            製品自動マッピング
          </el-button>
        </ScreenPermissionGate>
      </div>
      <div class="master-list-button-line">
        <ScreenPermissionGate code="ROLE_PERMISSION_SETTINGS">
          <el-button
            class="unit-master-list-button-role-permission"
            type="primary"
            size="large"
            @click="router.push('/master/role-permission')"
          >
            権限設定
          </el-button>
        </ScreenPermissionGate>
      </div>
    </template>
  </BaseSimpleLayout>
</template>

<script setup lang="ts">
  import BaseSimpleLayout from '@/components/BaseSimpleLayout.vue';
  import ScreenPermissionGate from '@/components/ScreenPermissionGate.vue';
  import router from '@/router';
</script>
<style lang="scss">
  .master-list {
    .master-list-button-line {
      margin: 20px 50px;
      text-align: initial;
    }
    button.el-button {
      font-weight: 600;
    }
  }
</style>
